// A `returnUrl` from the query string is attacker-controlled. Only same-site
// paths are allowed: "/assets?update=monthly" yes, "https://evil.example",
// "//evil.example" and "/\evil.example" (both protocol-relative in browsers) no.
export function safeReturnPath(value: string | null | undefined): string | null {
  if (!value || typeof value !== 'string') return null;
  if (!value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) return null;
  if (/[\u0000-\u001f]/.test(value)) return null;
  return value;
}

// Where to send a signed-out visitor so they come back to `path` after signing in.
export function loginUrlFor(pathWithQuery: string): string {
  const safe = safeReturnPath(pathWithQuery);
  return safe && safe !== '/' ? `/login?returnUrl=${encodeURIComponent(safe)}` : '/login';
}
